import { httpClient } from '../http/httpClient'

export const checkName = async (name: string) => {
  const { data } = await httpClient
    .get<boolean>(`/self-hire/check-name/${name}`)
    .catch((error) => {
      throw error?.response?.data || error
    })
  return data
}
